import React, {useEffect, useRef, useState} from 'react';

import './Skeleton.css';
import {Link, Outlet, useNavigate} from "react-router-dom";
import LanguageSelect from "../../components/LanguageSelect/LanguageSelect";
import NotificationsIcon from "../../components/NotificationsIcon/NotificationsIcon";
import NavigationDropdown from "../../components/Navigation/NavigationDropdown";
import Navigation from "../../components/Navigation/Navigation";
import TopProfile from "../../components/TopProfile/TopProfile";
import {CONFIG} from "../../config";
import {useSelector} from "react-redux";
import GroupSelect from "../../components/GroupSelect/GroupSelect";
import MeQuery from "../../queries/User/Me";
import Navbar from 'react-bootstrap/Navbar';
import ThemeToggle from "../../components/ThemeToggle/ThemeToggle";


export default function Skeleton() {
    const isLoading = useSelector((state) => state.loading.value);
    const [currentUser] = useState(JSON.parse(localStorage.getItem("me")));
    const [currentGroup, setCurrentGroup] = useState(null);
    const [width, setWidth] = useState();
    const navigate = useNavigate();
    const ref = useRef(null);
    const updateMeTimeoutRef = useRef(null);

    useEffect(() => {
        if (localStorage.getItem("current_group")) {
            setCurrentGroup(JSON.parse(localStorage.getItem("current_group")));
        } else {
            setCurrentGroup(JSON.parse(localStorage.getItem("me")).groups[0]);
        }
        document.body.classList.remove("account-body");
        document.body.classList.remove("login-page");
        updateMe();

        return () => {
            if (updateMeTimeoutRef.current) clearTimeout(updateMeTimeoutRef.current);
        };
    }, []);

    useEffect(() => {
        setWidth(ref.current.clientWidth);

        function handleWindowResize() {
            setWidth(ref.current.clientWidth);
        }

        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const updateMe = () => {
        MeQuery().then((result) => {
            if (result.status !== 200) {
                navigate("/logout");
                return;
            }

            let data = result.data.data;

            if (data.groups.length < 1) {
                navigate("/logout");
                return;
            }

            localStorage.setItem('me', JSON.stringify(data));

            updateMeTimeoutRef.current = setTimeout(updateMe, 10000);
        }, () => {
            //if (!localStorage) {
                navigate("/logout");
           // }
        });
    }

    return (<>
        {isLoading && <div className="loading">Loading&#8230;</div>}
        <div className="container">
            <div className="topbar">
                <nav className="topbar-main" style={{maxWidth: "1280px"}}>
                    <div className="topbar-left" style={{display: "flex"}}>
                        {currentGroup && width < 992 && <NavigationDropdown currentGroup={currentGroup}/>}
                        {width > 600 && <Link to="/" className="logo">

                            {(currentGroup && currentGroup.name === 'A1 Croatia') &&
                            <img
                                src="/images/logo-a1.jpg"
                                alt="Bercman"
                                className="logo-sm img-responsive"
                            />
                            }

                            {(!currentGroup || currentGroup.name !== 'A1 Croatia') &&
                                <img
                                    src="/images/logo-dark.png"
                                    alt="Bercman"
                                    className="logo-sm img-responsive bercman-logo"
                                />
                            }


                        </Link>}
                    </div>
                    <Navbar className='custom-navbar-right'>
                        {currentGroup && <GroupSelect currentGroup={currentGroup}/>}
                        <LanguageSelect width={width}/>
                        <ThemeToggle/>
                        {currentUser && currentGroup && currentGroup.id === 1 && <NotificationsIcon/>}
                        <TopProfile/>
                    </Navbar>

                </nav>
                <div ref={ref} className="navbar-custom-menu" style={(currentGroup && currentGroup.name === 'A1 Croatia') ? {background: "linear-gradient(135deg, #e94b43, #c93b3f)"} : {background: "linear-gradient(135deg, #4d79f6, #3d63d6)"}}>
                    <div className="container-fluid" style={{maxWidth: "1280px"}}>
                        {currentGroup && width > 991 && <Navigation currentGroup={currentGroup} currentUser={currentUser}/>}
                    </div>
                </div>
            </div>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="container-fluid">
                        <Outlet/>
                    </div>
                </div>
                <footer className="footer text-center text-sm-left">
                    <div className="boxed-footer">
                        <span>© 2019-{new Date().getFullYear()} Bercman Technologies AS</span>
                        <span className="footer-divider">&middot;</span>
                        <span>Control Hub {CONFIG.VERSION}</span>
                    </div>
                </footer>
            </div>
        </div>
    </>);
}